export class CCheckbox extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    const label = this.getAttribute("label") || "";
    const isChecked = this.hasAttribute('checked');
    const isDisabled = this.hasAttribute("disabled");
    const hasError = this.hasAttribute('error');

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          gap: 4px;
          user-select: none;
          opacity: ${isDisabled ? '0.5' : '1'}
        }

        input[type="checkbox"] {
          appearance: none;
          width: 20px;
          height: 20px;
          border: 2px solid ${hasError ? 'none' : 'var(--tempora-primary-300)'};
          border-radius: 4px;
          display: grid;
          place-content: center;
          background-color: ${hasError ? 'var(--error-easy)' : 'var(--tempora-primary-100)'};
          transition: all 0.2s ease;
        }

        input[type="checkbox"]:checked {
          background-color: var(--tempora-primary);
          border-color: var(--tempora-primary)
        }

        input[type="checkbox"]::before {
          content: "✓";
          color: var(--white);
          font-size: 14px;
          transform: scale(0);
          transition: transform 0.2s ease;
        }
        input:checked + span {
           color: var(--black)
        }
        input[type="checkbox"]:checked::before {
          transform: scale(1);
        }
        input:checked:hover {
            background-color: ${!isDisabled ? 'var(--tempora-primary-active)' : 'var(--tempora-primary)'};
            border-color: ${!isDisabled ? 'var(--tempora-primary-active)' : 'var(--tempora-primary)'};
        }
        input:hover{
            background-color: ${hasError ? 'var(--error-easy)' : 'var(--tempora-primary-200)'};
            border-color: var(--tempora-primary-300)
        }

        label {
          color: ${hasError ? 'var(--error)' : 'var(--black)'};
          font-size: 15px;
          display: flex;
          align-items: center;
          gap: 5px
        }
        span{
            font-size: 14px
        }
      </style>

      <label>
        <input type="checkbox" ${isChecked ? 'checked' : ''} ${isDisabled ? 'disabled' : ''}>
        <span>${label}</span>
      </label>
    `;
  }
}

customElements.define("c-checkbox", CCheckbox);